import { memo, type PropsWithChildren } from "react";
import Button, { type ButtonProps } from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import type { WithSlots } from "types";
import When from "ui/support/When";

type Props = WithSlots<
    PropsWithChildren,
    {
        readonly action: ButtonProps;
    }
>;

const UBOIdentityVerificationTitle = ({ children, slotProps }: Props) => {
    const {
        startIcon,
        children: actionChildren,
        ...actionProps
    } = slotProps?.action || {};

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 1
            }}
        >
            {children}
            <When
                if={Boolean(slotProps?.action)}
                then={(
                    <When
                        if={Boolean(actionChildren)}
                        then={() => (
                            <Button
                                {...actionProps}
                                startIcon={startIcon}
                            >
                                {actionChildren}
                            </Button>
                        )}
                        else={() => (
                            <IconButton
                                {...actionProps}
                            >
                                {startIcon}
                            </IconButton>
                        )}
                    />
                )}
            />
        </Box>
    );
};

export default memo(UBOIdentityVerificationTitle);
